export const ANALYTICS_IDENTIFIER_KEY = '__analytics__'
